// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1eIPm","paramInput":"JobSimulator_paramInput__ioIUu","input":"JobSimulator_input__2fWDc"};